<template>
  <v-container class="minHeight">
    <v-card v-if="isSmallScreen" class="pb-3">
      <v-toolbar class="primary" flat :class="{ 'py-3': isSmallScreen }">
        <v-layout row wrap>
          <v-flex xs12 class="align-self-center">
            <span class="white--text headline left mb-3" v-html="getBalance">
            </span>
          </v-flex>
        </v-layout>
      </v-toolbar>
    </v-card>

    <v-card class="pb-3">
      <v-toolbar
        class="secondary"
        flat
        :height="toolbarHeight"
        :class="{ 'py-3': isSmallScreen }"
      >
        <v-layout row wrap>
          <v-flex xs12 sm9 class="align-self-center" v-if="hasCoupon()">
            <span
              class="white--text headline"
              :class="{ 'left mb-3': isSmallScreen }"
              v-html="getTitleUsedCoupon"
            >
            </span>
          </v-flex>
          <v-flex xs12 sm3 v-if="hasCoupon()">
            <v-btn
              round
              @click="cleanCupon"
              color="white"
              :block="isSmallScreen"
              :class="{ right: !isSmallScreen }"
              class="accent font-weight-bold initialize"
              v-html="$t('buy.packs.cleanCoupon')"
            ></v-btn>
          </v-flex>
          <v-flex xs12 sm9 class="align-self-center" v-if="!hasCoupon()">
            <span
              class="white--text headline"
              :class="{ 'right mb-3': isSmallScreen }"
              v-html="getTitlePerCountry"
            >
            </span>
          </v-flex>
          <v-flex xs12 sm3 v-if="!hasCoupon()">
            <v-btn
              round
              @click="showCouponModal"
              color="white"
              :block="isSmallScreen"
              :class="{ right: !isSmallScreen }"
              class="accent font-weight-bold initialize"
              v-html="$t('buy.packs.applyCoupon')"
            ></v-btn>
          </v-flex>
        </v-layout>
      </v-toolbar>

      <coupon
        @on-submit="loadProducts"
        @on-close="onCloseCouponModal"
        v-if="isShowingCouponModal"
      >
      </coupon>

      <advice color="primary" class="mt-4" v-if="showRegisterGift">
        <span v-html="messageRegisterGift"></span>
      </advice>

      <v-layout row wrap class="mt-3">
        <template v-for="product in products">
          <v-flex :key="product.id" xs12 sm6 lg4 class="pa-2">
            <v-card height="100%" hover @click="buyOrGetProduct(product)">
              <v-img
                :src="`/image/private/packs/${product.image}`"
                gradient="to top right, rgba(100,115,201,.33), rgba(25,32,72,.7)"
                min-height="250"
                aspect-ratio="4.00"
              >
                <v-layout pa-3 column fill-height class="white--text">
                  <v-flex shrink>
                    <div class="headline">
                      <b>{{ product.name }}</b>
                    </div>
                  </v-flex>
                  <v-spacer></v-spacer>
                  <v-flex shrink>
                    <div class="headline right">
                      <template v-if="product.couponCode && product.price == 0">
                        <div class="display-2 font-weight-bold text-xs-right">
                          <label>{{ product.discountFormat }}</label>
                        </div>

                        <template v-if="product.hasDiscount">
                          <div
                            class="display-1 font-weight-medium text-xs-right"
                          >
                            <label
                              class="headline"
                              v-html="$t('buy.packs.pack.free')"
                            ></label>
                          </div>
                        </template>
                      </template>
                      <template v-else>
                        <div class="display-2 font-weight-bold text-xs-right">
                          {{ product.priceFormat }}
                        </div>

                        <template v-if="product.hasDiscount">
                          <div
                            class="display-1 font-weight-medium text-xs-right"
                          >
                            <label>+{{ product.discountFormat }}</label>
                            <label
                              class="headline"
                              v-html="$t('buy.packs.pack.free')"
                            ></label>
                          </div>
                        </template>
                      </template>
                    </div>
                  </v-flex>
                </v-layout>
              </v-img>

              <v-card-actions class="pa-0 white justify-center" dark>
                <template v-if="product.couponCode && product.price == 0">
                  <v-btn
                    flat
                    block
                    class="accent capitalize"
                    v-html="$t('buy.packs.pack.get')"
                  ></v-btn>
                </template>
                <template v-else>
                  <v-btn
                    flat
                    block
                    class="accent capitalize"
                    v-html="$t('buy.packs.pack.buy')"
                  ></v-btn>
                </template>
              </v-card-actions>
            </v-card>
          </v-flex>
        </template>
      </v-layout>

      <advice color="primary" class="mt-4">
        <span class="caption grey--text text--darken-1">
          <ul style="list-style: none" class="pa-0">
            <li
              v-if="isChile"
              class="py-1"
              v-html="$t('buy.packs.legend.averagePrice')"
            ></li>
            <li class="py-1" v-html="$t('buy.packs.legend.taxes')"></li>
            <li class="py-1" v-html="$t('buy.packs.legend.nonExpire')"></li>
          </ul>
        </span>
      </advice>
    </v-card>
    <payment-gateway
      @on-close="onClosePaymentGateway"
      :product="selectedProduct"
      :open-automatically="openAutomatically"
      v-if="isShowPaymentGatewayModal"
    ></payment-gateway>
  </v-container>
</template>

<script>
import Advice from '@/components/commons/Advice';
import Coupon from '@/components/private/balance/Coupon';
import PaymentGateway from '@/components/private/balance/PaymentGateway';
import manageErrorService from '@/services/manageErrorService';
import paymentService from '@/services/paymentService';
import productService from '@/services/productService';
import keys from '@/store/keys';
import { EventBus } from '@/services/eventBus';
import sessionService from '@/services/sessionService';
import store from '@/store';
import utilService from '@/services/utilService';
import _ from 'lodash';
import moment from 'moment';

export default {
  name: 'Buy',
  components: {
    [Advice.name]: Advice,
    [Coupon.name]: Coupon,
    [PaymentGateway.name]: PaymentGateway,
  },
  computed: {
    getTitlePerCountry() {
      let text = this.$i18n.t('buy.packs.title.inHours', {
        priceHour: this.priceHour,
      });

      if (utilService.isChile()) {
        text = this.$i18n.t('buy.packs.title.inMinutesDifferentPrice', {
          priceMinute: this.priceMinute,
        });
      } else if (utilService.isSpain()) {
        text = this.$i18n.t('buy.packs.title.inHoursDifferentPrice', {
          priceHour: this.priceHour,
        });
      }

      return text;
    },
    getTitleUsedCoupon() {
      let text = this.$i18n.t('buy.packs.title.usingCoupon', {
        usedCoupon: this.usedCoupon,
      });
      return text;
    },
    isSmallScreen() {
      return this.$vuetify.breakpoint.xs;
    },
    toolbarHeight() {
      return this.$vuetify.breakpoint.xs ? '150px' : null;
    },
    priceHour() {
      let hour = store.state.countrySelected.prices.hour;
      return this.$options.filters.addCurrencySymbol(hour);
    },
    priceMinute() {
      let minute = store.state.countrySelected.prices.minute;
      return this.$options.filters.addCurrencySymbol(minute);
    },
    isChile() {
      return utilService.isChile();
    },
    showRegisterGift() {
      return (
        moment(store.state.user.balance.expirationDateLocal).diff(
          moment(),
          'days'
        ) > 0
      );
    },
    messageRegisterGift() {
      let days = moment(store.state.user.balance.expirationDateLocal).diff(
        moment(),
        'days'
      );
      let pendingGift = store.state.user.balance.remainingAmountWithCurrency;

      return this.$i18n.t('buy.packs.pack.registerGift', {
        days: days,
        pendingGift: pendingGift,
      });
    },
    getBalance() {
      let text = this.$i18n.t('buy.balance.title', {
        userBalance: store.state.user.balance.totalWithCurrency,
      });

      return text;
    },
  },
  data() {
    return {
      usedCoupon: '',
      products: [],
      selectedProduct: {},
      isShowingCouponModal: false,
      isShowPaymentGatewayModal: false,
      openAutomatically: false,
    };
  },
  async mounted() {
    if (typeof this.$route.query.ok !== 'undefined') {
      this.openAutomatically = false;
      let message = 'global.buy.error';
      let type = 'error';
      let doNotTranslate = false;
      let emitNotification = true;

      if (this.$route.query.ok.indexOf('OK') >= 0) {
        const balanceTotal = store.state.balanceBeforeBuying;
        await sessionService.check(true);
        const newBalanceTotal = store.state.user.balance.total;
        if (balanceTotal === newBalanceTotal) {
          EventBus.$emit(keys.polBalance, {});
          emitNotification = false;
        } else {
          store.commit('UPDATE_BALANCE_BEFORE_BUYING', {
            balanceBeforeBuying: newBalanceTotal,
          });
          message = 'global.buy.success';
          type = 'success';
        }

        this.$router.replace({ path: this.$router.path });
      } else {
        let errorMessageData = await paymentService.getErrorCause(
          this.$route.query.paymentId
        );
        message = `<strong>${
          errorMessageData.data.message
        }.</strong> <br/> ${this.$i18n.t('global.buy.error')}.`;
        doNotTranslate = true;

        let responseShouldRetry = await paymentService.getShouldRetry(
          this.$route.query.paymentId
        );
        if (
          !responseShouldRetry.error &&
          responseShouldRetry.data.shouldRetry
        ) {
          this.selectedProduct = store.state.lastSelectedProduct;
          this.openAutomatically = true;
          this.isShowPaymentGatewayModal = true;
        }
      }

      if (emitNotification) {
        EventBus.$emit(keys.eventOnShowNotification, {
          title: '',
          message: message,
          type: type,
          doNotTranslate: doNotTranslate,
          timeout: 10000,
          isHtml: true,
        });
      }
    } else {
      // Para ver si hay que mostrar el saldo de regalo
      // TODO: CHIW: Duda, el saldo del usuario sólo veo que se actualize en contadas situaciones, puede ser problemático
      // el check se hace siempre que se entra a una ruta
      // await sessionService.check(false);
    }
  },
  created() {
    this.loadProducts(this.$route.query);
    EventBus.$on(keys.eventOnCloseModal, this.onClosePaymentGateway);
  },
  destroyed() {
    EventBus.$off(keys.eventOnCloseModal, this.onClosePaymentGateway);
  },
  methods: {
    async loadProducts(params) {
      this.isShowingCouponModal = false;
      this.usedCoupon = '';

      let p = {};

      if (typeof params !== 'undefined') {
        p.couponCode = params.cupon;
      }

      let results = await productService.list(p);

      if (results.error) {
        manageErrorService.handle(results.data);
        if (p.couponCode) {
          this.loadProducts();
        }
        return;
      }

      if (typeof params !== 'undefined') {
        this.usedCoupon = params.cupon;
      }

      let pigs = ['pig-small.jpg', 'pig-medium.jpg', 'pig-big.jpg'];
      this.products = _.map(results.data, (element) => {
        if (p.couponCode) {
          return _.extend({}, element, {
            image: 'pig-promo.jpg',
            couponCode: p.couponCode,
          });
        } else if (element.code === 'NO_BALANCE') {
          return _.extend({}, element, {
            image: 'pig-debt.jpg',
            couponCode: null,
          });
        } else if (element.code === 'HN499') {
          return _.extend({}, element, {
            image: 'pig-mini.jpg',
            couponCode: null,
          });
        } else if (pigs.length > 0) {
          let img = _.head(pigs);
          pigs = _.tail(pigs);
          return _.extend({}, element, { image: img, couponCode: null });
        } else {
          return _.extend({}, element, {
            image: 'pig-big.jpg',
            couponCode: null,
          });
        }
      });

      this.isLoadingCoupon = false;
      // this.showCouponSheet = false;
    },
    onClosePaymentGateway() {
      this.isShowPaymentGatewayModal = false;
    },
    onCloseCouponModal() {
      this.isShowingCouponModal = false;
    },
    showCouponModal() {
      this.isShowingCouponModal = true;
    },
    hasCoupon() {
      return typeof this.usedCoupon !== 'undefined' && this.usedCoupon !== '';
    },
    cleanCupon() {
      this.usedCoupon = '';
      this.loadProducts();
    },
    showPaymentGatewayModal(product) {
      this.openAutomatically = false;
      store.commit('UPDATE_LAST_SELECTED_PRODUCT', {
        selectedProduct: product,
      });
      this.selectedProduct = product;
      this.isShowPaymentGatewayModal = true;
    },
    async buyOrGetProduct(product) {
      if (product.couponCode && product.price === 0) {
        const payload = {
          productId: product.id,
          couponCode: product.couponCode,
          city: store.state.citySelected.name,
        };
        const result = await productService.useFreeProductCoupon(payload);
        if (result.error) {
          EventBus.$emit(keys.eventOnShowNotification, {
            title: '',
            message: 'global.buy.error',
            type: 'error',
            doNotTranslate: false,
            timeout: 10000,
            isHtml: true,
          });

          return;
        }
        await sessionService.check(true);

        EventBus.$emit(keys.eventOnShowNotification, {
          title: '',
          message: 'global.buy.success',
          type: 'success',
          doNotTranslate: false,
          timeout: 10000,
          isHtml: true,
        });

        this.usedCoupon = '';
        this.loadProducts();

        return;
      }
      this.showPaymentGatewayModal(product);
    },
  },
};
</script>

<style lang="scss" scoped>
// .flexcard {
//   display: flex;
//   flex-direction: column;
// }
.price {
  text-align: right;
  color: #767682;
}
.discount {
  text-align: right;
  // color:#5c9063;
  color: #767682;
}
.discountLabel {
  text-align: right;
}
</style>
